import {
  ListItem,
  Checkbox,
  Paper,
  Stack,
  // Box,
  Typography,
  Grid,
  Link,
} from "@mui/material";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { paginateArray } from "../helpers/paginateArray";
import ProgressBar from "./ProgressBar";
import UserControl from "../Dialogs/UserControl";
dayjs.extend(relativeTime);

export default function ChecklistCard(props) {
  return (
    <div>
      {paginateArray(props.checklists, props.page, props.rowsPerPage).map(
        (obs, idx) => (
          <ListItem key={idx} style={{ padding: 0 }}>
            <Paper
              elevation={6}
              style={{ width: "100%", marginTop: 10, marginBottom: 10 }}
            >
              <div style={{ padding: 12 }}>
                <ProgressBar
                  value={parseInt(
                    (obs.rows.filter(
                      (row) =>
                        (row.hasOwnProperty("value") &&
                          row.value.length > 0 &&
                          row["Row Type"] !== "Header" &&
                          row["Row Type"] !== "Information Row") ||
                        (row.hasOwnProperty("value") &&
                          row.value.hasOwnProperty("url") &&
                          row.value.url.length > 0 &&
                          row["Row Type"] !== "Header" &&
                          row["Row Type"] !== "Information Row"),
                    ).length /
                      obs.rows.filter(
                        (row) =>
                          row["Row Type"] !== "Header" &&
                          row["Row Type"] !== "Information Row",
                      ).length) *
                      100,
                  )}
                />
                <Grid container spacing={0}>
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        id={obs.id}
                        name={obs.id}
                        checked={obs.Selected ? obs.Selected : false}
                        onChange={props.handleChecked}
                      />
                      <Link
                        variant="h6"
                        gutterBottom
                        underline="hover"
                        href={`/project/${props.projectId}/checklist/${obs.id}`}
                        color="secondary.main"
                      >{`${obs["Asset Name"]}-${obs["Name"]}`}</Link>
                    </Stack>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        color="secondary.light"
                      >{`Checklist Type:`}</Typography>
                      <Typography
                        style={{ marginLeft: 6 }}
                      >{`${obs["Checklist Type"]}`}</Typography>
                    </Stack>
                  </Grid>

                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        color="secondary.light"
                      >{`Assigned to:`}</Typography>
                      <Typography
                        style={{ marginLeft: 6 }}
                      >{`${obs["Assigned to"]}`}</Typography>
                    </Stack>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        color="secondary.light"
                      >{`Total Rows:`}</Typography>
                      <Typography
                        style={{ marginLeft: 6 }}
                      >{`${obs["rows"].length}`}</Typography>
                    </Stack>
                  </Grid>

                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <UserControl
                      isCreator={true}
                      user={obs["Created By"].toString()}
                      uid={obs["Creator UID"]?obs["Creator UID"]:obs["Created By"]}
                    />
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="caption"
                        gutterBottom
                        color="secondary.light"
                      >{`Created Date:`}</Typography>
                      <Typography
                        style={{ marginLeft: 4 }}
                        variant="caption"
                        gutterBottom
                      >
                        {`${new Date(
                          obs["Created Date"].seconds * 1000,
                        ).toLocaleDateString()}
              
                 (${dayjs(
                   new Date(obs["Created Date"].seconds * 1000),
                 ).fromNow()})`}
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                    <UserControl
                      isCreator={false}
                      user={obs["Modified By"].toString()}
                      uid={
                        obs["Modifier UID"]
                          ? obs["Modifier UID"]
                          : obs["Modified By"]
                      }
                    />
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="caption"
                        gutterBottom
                        color="secondary.light"
                      >{`Modified Date:`}</Typography>
                      <Typography
                        style={{ marginLeft: 4 }}
                        variant="caption"
                        gutterBottom
                      >
                        {`${new Date(
                          obs["Modified Date"].seconds * 1000,
                        ).toLocaleDateString()}  (${dayjs(
                          new Date(obs["Modified Date"].seconds * 1000),
                        ).fromNow()})`}
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}></Grid>
                </Grid>

                {/* ${new Date(
                        obs["Modified Date"].seconds * 1000
                      ).toLocaleTimeString()} */}
              </div>
            </Paper>
          </ListItem>
        ),
      )}
    </div>
  );
}
